import { deviceDetector, getDeviceParser } from "utils";

/**
 * 统一主壳（四 Tab 单 WebView）首发最低 build。
 * 发版前填入真实 build；为 0 表示尚未配置，prod 下永不走统一主壳分支。
 */
export const IOS_UNIFIED_MAIN_SHELL_MIN_BUILD = 287;
export const ANDROID_UNIFIED_MAIN_SHELL_MIN_BUILD = 110;

/**
 * [App 版本兼容] 当前客户端是否为「统一主壳」App（Brief/Invest/Plan/Desk 单 WebView）。
 * 以 build 为准，不依赖 `__EDGEN_UNIFIED_MAIN_SHELL__` 注入是否成功。
 */
export function supportsUnifiedNativeMainShell(): boolean {
  if (
    process.env.NEXT_PUBLIC_ENV !== "prod" &&
    process.env.NEXT_PUBLIC_ENV !== "edgen_prod"
  ) {
    return true;
  }
  // 常量仍为 0 表示 Web 先发、App 未上架：prod 永不启用统一主壳
  if (
    IOS_UNIFIED_MAIN_SHELL_MIN_BUILD <= 0 &&
    ANDROID_UNIFIED_MAIN_SHELL_MIN_BUILD <= 0
  ) {
    return false;
  }
  return !!(
    (deviceDetector.isAndroidApp() &&
      ANDROID_UNIFIED_MAIN_SHELL_MIN_BUILD > 0 &&
      Number(getDeviceParser().buildNumber) >=
        ANDROID_UNIFIED_MAIN_SHELL_MIN_BUILD) ||
    (deviceDetector.isIOSApp() &&
      IOS_UNIFIED_MAIN_SHELL_MIN_BUILD > 0 &&
      Number(getDeviceParser().buildNumber) >= IOS_UNIFIED_MAIN_SHELL_MIN_BUILD)
  );
}
